import { render, staticRenderFns } from "./IngredientsGroup.vue?vue&type=template&id=d5e77fc4&scoped=true"
import script from "./IngredientsGroup.vue?vue&type=script&lang=js"
export * from "./IngredientsGroup.vue?vue&type=script&lang=js"
import style0 from "./IngredientsGroup.vue?vue&type=style&index=0&id=d5e77fc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e77fc4",
  null
  
)

export default component.exports